import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {Helmet} from 'react-helmet';
import parser from 'url-parse';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { catalogMailingListsActions } from '../../data/actions/catalog_mailing_lists';
import { catalogMailingListsSettings } from '../../components/pages/catalogMailingLists/Settings'
import Spinner from '../../components/common/Spinner'

const globalFilterList = [
	"limit",
	"range",
	"active",
	"genres",
	"dateEnd",
	"sources",
	"vendors",
	"dateStart",
	"firstDays",
	"forcePrev",
	"filteredBy",
	"releaseEnd",
	"contentType",
	"prevDateEnd",
	"territories",
	"audioFormats",
	"releaseStart",
	"prevDateStart",
	"completeVendors",
	"incompleteVendorsList"
]

class CatalogReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
		this.deleteList = this.deleteList.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(catalogMailingListsActions.getCatalogMailingLists());
	}
	
	deleteList(id) {
		this.props.dispatch(catalogMailingListsActions.deleteCatalogMailingList(id));
	}

	
	
	render() {
		const { loading, catalogMailingLists } = this.props.mailingLists;
		return (
			<div className="inner-page shared-pages catalog-report-page">
				<div className="ibox">
					<div className="catalog-report-title-holder">
						<h2 className="saved-filter-title">Reports</h2>
						<div className="catalog-report-warning">
							Access to full catalog reports is available on request. Contact your administrator for access.
						</div>
					
						<div className="buttons-holder">
							<Link to="/user/catalog-report/new" className="default-btn default-btn--small create-new-filter">Add New</Link>
						</div>
					</div>
					<ReactTable
						data={catalogMailingLists}
						loading={loading}
						columns={catalogMailingListsSettings.settingsForTable(this.deleteList)}
					/>
				</div>
				<Helmet>
					<title>Catalog Reports</title>
				</Helmet>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		mailingLists: state.catalogMailingLists
	} 
}


export default connect(mapStateToProps)(withRouter(CatalogReportList));